import { apiClient } from "@/lib/axios";
import type { User } from "../schemas/user.schema";
import { parseJSON, type JSONAPIQuery } from "@/lib/parser";

export const getCurrentUser = async (query: JSONAPIQuery = {}) => {
  const { data } = await apiClient.get(
    '/v1/users/me',
    {
      params: query
    }
  );
  
  return parseJSON<User>(data);
}
